import { useTranslation } from 'react-i18next';

export default function CompensationHistory({ compensations }) {
    const { t } = useTranslation();

    return <fieldset className="col-xs-12">
        <legend>{t('compensationhistory.compensationhistory')}</legend>
        <div className="table-container">
            <table className="table table-stripe">
                <thead>
                    <tr>
                        <th className="text-left">{t('compensationhistory.program')}</th>
                        <th className="text-left">{t('compensationhistory.months')}</th>
                        <th className="text-left">{t('compensationhistory.reason')}</th>
                        <th className="text-left">{t('compensationhistory.sum')}</th>
                        <th className="text-left">{t('compensationhistory.salesforceticketlink')}</th>
                        <th className="text-left">{t('compensationhistory.createdby')}</th>
                    </tr>
                </thead>
                <tbody>
                    {compensations && compensations.length > 0 ? compensations.map((item, index) => {
                        return <tr key={index}>
                            <td className="text-left">{item.productName}</td>
                            <td className="text-left">{item.months}</td>
                            <td className="text-left">{item.reasonName}</td>
                            <td className="text-left">{item.sum}</td>
                            <td className="text-left"><a href={item.salesforceTicketLink} target='_blank' rel="noopener noreferrer">{item.salesforceTicketLink}</a></td>
                            <td className="text-left">{item.email}</td>
                        </tr>
                    }) : (
                        <tr>
                            <td colSpan={6}>{t('compensationhistory.noCompensationHistory')}</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    </fieldset>
}